(function () {
  function parseMoneyToCents(text) {
    if (!text) return null;
    const cleaned = String(text).replace(/[^0-9.]/g, "");
    if (!cleaned) return null;
    const num = parseFloat(cleaned);
    if (!Number.isFinite(num)) return null;
    return Math.round(num * 100);
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents);
    }
    return `$${(cents / 100).toFixed(2)}`;
  }

  function getPackCount(scope) {
    const checked = scope.querySelector(
      'input.var-input[type="radio"][name="1"]:checked'
    );
    if (!checked) return null;
    const m = String(checked.value || "").match(/\d+/);
    return m ? parseInt(m[0], 10) : null;
  }

  function getSubscriptionDiscount(buyBox) {
    const subRadio = buyBox.querySelector('input[name="has_plan"]:checked');
    if (!subRadio || subRadio.value !== "true") return null;

    const sellingPlan = buyBox.querySelector("selling-plan");
    if (!sellingPlan) return null;

    const discountPct = parseFloat(sellingPlan.dataset.discountPct);
    return Number.isFinite(discountPct) ? discountPct : null;
  }

  function syncDiscountPct(sellingPlan) {
    const planSelect = sellingPlan.querySelector("select");
    if (!planSelect) return;
    const selectedOption = planSelect.options[planSelect.selectedIndex];
    const pct = selectedOption
      ? parseFloat(selectedOption.dataset.discountPct)
      : NaN;
    sellingPlan.dataset.discountPct = Number.isFinite(pct) ? pct : "";
  }

  function updateDisplayPrice(buyBox, obs) {
    const priceEl = buyBox.querySelector("[data-variant-price]");
    if (!priceEl) return;

    if (!priceEl.dataset.baseCents) {
      const initial = parseMoneyToCents(priceEl.textContent);
      if (!initial) return;
      priceEl.dataset.baseCents = initial;
    }

    const baseCents = parseInt(priceEl.dataset.baseCents, 10);
    if (!baseCents) return;

    const discountPct = getSubscriptionDiscount(buyBox);
    const newCents =
      discountPct != null
        ? Math.round(baseCents * (1 - discountPct / 100))
        : baseCents;
    const newText = formatMoney(newCents);

    if (priceEl.textContent === newText) return;

    // Disconnect observer before writing to prevent mutation loop
    if (obs) obs.disconnect();
    priceEl.textContent = newText;
    if (obs) obs.observe(priceEl, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  function updatePerCan(buyBox) {
    const priceEl = buyBox.querySelector("[data-variant-price]");
    const out = buyBox.querySelector("[data-per-can]");
    if (!priceEl || !out) return;

    const sizeChecked = buyBox.querySelector(
      'input.var-input[type="radio"][name="1"]:checked'
    );
    if (!sizeChecked) {
      out.textContent = "";
      return;
    }

    const sizeText = (sizeChecked.value || "").toLowerCase();
    if (!sizeText.includes("pack")) {
      out.textContent = "";
      return;
    }

    // Always read from baseCents if available to stay consistent
    const priceElBaseCents = parseInt(priceEl.dataset.baseCents, 10);
    const cents = priceElBaseCents || parseMoneyToCents(priceEl.textContent);
    const pack = getPackCount(buyBox);

    if (!cents || !pack || pack <= 0) {
      out.textContent = "";
      return;
    }

    const discountPct = getSubscriptionDiscount(buyBox);
    const effectiveCents =
      discountPct != null ? Math.round(cents * (1 - discountPct / 100)) : cents;

    const perCan = effectiveCents / pack / 100;
    out.textContent = ` ($${perCan.toFixed(2)} / Can)`;
  }

  function updateAll(buyBox, obs) {
    updateDisplayPrice(buyBox, obs);
    updatePerCan(buyBox);
  }

  function init(buyBox) {
    if (!buyBox || buyBox.__perCanInit) return;
    buyBox.__perCanInit = true;

    const sellingPlan = buyBox.querySelector("selling-plan");
    if (sellingPlan) syncDiscountPct(sellingPlan);

    const priceEl = buyBox.querySelector("[data-variant-price]");
    let obs = null;

    if (priceEl && window.MutationObserver) {
      obs = new MutationObserver(() => {
        // Price changed externally (variant switch): clear cache and re-run
        delete priceEl.dataset.baseCents;
        updateAll(buyBox, obs);
      });
      obs.observe(priceEl, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    }

    let tries = 0;
    const tick = () => {
      updateAll(buyBox, obs);
      tries += 1;
      if (tries < 30) setTimeout(tick, 150);
    };
    tick();

    buyBox.addEventListener("change", (e) => {
      const t = e.target;
      if (!t || !t.matches) return;

      if (t.matches('input.var-input[type="radio"][name="1"]')) {
        setTimeout(() => updateAll(buyBox, obs), 0);
        return;
      }

      if (
        t.matches('input[name="has_plan"]') ||
        t.matches("selling-plan select")
      ) {
        const sellingPlan = buyBox.querySelector("selling-plan");
        if (sellingPlan) syncDiscountPct(sellingPlan);
        setTimeout(() => updateAll(buyBox, obs), 0);
      }
    });
  }

  function boot() {
    document.querySelectorAll("buy-box").forEach(init);
  }

  document.addEventListener("DOMContentLoaded", boot);
  window.addEventListener("load", () => {
    setTimeout(boot, 250);
    setTimeout(boot, 1000);
  });
})();